import { fromJS } from 'immutable';

import { ApiListTemplate, UserToken } from '../../../helper/HelperAuth'
import {GetHSMTemplate, GlobalLoading} from '../../../store/constants'
import doFetch from '../../../infra/helper/fetchHelper'

export default (page, body) => async (dispatch, getState) => {
    dispatch({ type: GlobalLoading, showLoading: true});
    const Authorization = UserToken;


    const url = ApiListTemplate + 'config-hsmtemplate-list';

    if(page === undefined){
        page = 1;
    }

    var query = {
        "search":body,
        "page":page,
        "page-size":10,
        "order-by":6,
        "order":"DESC",
    };


    var paramBody = {
        "query": query
    };


    const argument = {
        method: 'POST',
        headers : {
            'Content-Type':'application/json',
            'Authorization': Authorization,
        },
        body : JSON.stringify(paramBody)
    };

    const response = await doFetch(url,argument);

    var data = fromJS({});

    if(response.ok){
        data = fromJS(await response.json());
        var items = []
        var statusText="";
        data.get('data').map((item) => {
            var temp = item.get('data');
            if(item.get('status')===0){
                statusText="New";
            }else if(item.get('status')===1){
                statusText="Approved";
            }else{
                statusText="Rejected";
            }
            items.push({
                'row-num': item.get('row-num'),
                'template-id': item.get('template-id'),
                'namespace': item.get('namespace'),
                'param-size': item.get('param-size'),
                'raw-message': item.get('raw-message'),
                'status': item.get('status'),
                'template-name': item.get('template-name'),
                'type': item.get('media-type'),
                'status-text': statusText
            })
        })

        var data2 = {
            'row-count': data.get('row-count'),
            'page-size': data.get('page-size'),
            'page-count': data.get('page-count'),
            'order-by': data.get('order-by'),
            'page': data.get('page'),
            'order': data.get('order'),
            'data': items
        }
    }

    dispatch({ type: GlobalLoading, showLoading: false});

    dispatch({ type: GetHSMTemplate, data: fromJS(data2) });
};